import { render, staticRenderFns } from "./ModalEditBudget.vue?vue&type=template&id=36350d46&"
import script from "./ModalEditBudget.vue?vue&type=script&lang=js&"
export * from "./ModalEditBudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports